// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: black;
  color: #888;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  height: 60px;
}

.header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50px;
  right: 50px;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
}

body, html {
  background: #000 !important;
}

body {
  padding-top: 60px;
}

a.custom-link {
  display: inline-block;
  padding: 10px 24px;
  background: linear-gradient(90deg, #ff2e63 0%, #ff6f91 100%);
  color: #fff;
  border-radius: 8px;
  font-weight: bold;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  transition: background 0.2s, transform 0.2s;
}

a.custom-link:hover {
  background: linear-gradient(90deg, #ff6f91 0%, #ff2e63 100%);
  color: #fff;
  transform: translateY(-2px) scale(1.04);
  text-decoration: none;
}

.header-left {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
  font-size: 24px;
  font-weight: bold;
  color: #ff2e63;
  text-decoration: none;
}

.logo-image {
  width: 130px;
  height: auto;
  object-fit: contain;
  margin-left: 15px;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 35px;
  margin: 0;
  padding: 0;
  height: 60px;
  align-items: center;
}

.nav-menu li {
  font-size: 16px;
  cursor: pointer;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-menu li a {
  text-decoration: none;
  color: #888;
  transition: all 0.3s;
  padding: 21px 0;
  position: relative;
}

.nav-menu li::after {
  content: '';
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: transparent;
  transition: background-color 0.3s;
}

.nav-menu li:hover::after {
  background-color: rgba(255, 255, 255, 0.3);
}

.nav-menu li.active::after {
  background-color: white;
}

.nav-menu li.active a {
  color: white;
}

.nav-menu li:hover a {
  color: white;
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 15px;
  gap: 15px;
}

.auth-buttons {
  display: flex;
  align-items: center;
  gap: 20px;
}

.search-button,
.notification-button {
  background: none;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

.login-button,
.signup-button {
  background: none;
  border: 1px solid white;
  color: white;
  padding: 8px 16px;
  border-radius: 5px;
  text-decoration: none;
  font-size: 14px;
  transition: 0.3s;
}

.signup-button {
  background-color: #ff2e63;
  border: none;
}

.login-button:hover,
.signup-button:hover {
  opacity: 0.8;
}

/*검색 영역 스타일 */
.search-container {
  display: flex;
  align-items: center;
  background-color: #222;
  border-radius: 20px;
  padding: 5px 10px;
  width: 280px;
  position: relative;
}

.search-input {
  border: none;
  outline: none;
  background: transparent;
  color: white;
  width: 100%;
  padding: 5px;
  font-size: 14px;
  transition: opacity 0.4s ease;
}

.search-input.fade-out {
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.search-input.fade-in {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.search-icon {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  margin-left: 5px;
  font-size: 18px;
}

.clear-btn {
  background: none;
  border: none;
  color: gray;
  cursor: pointer;
  font-size: 14px;
  position: absolute;
  right: 10px;
}

.clear-btn:hover {
  color: white;
}

.notification-icon {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  margin-right: 10px;
}

/*반응형*/
@media screen and (max-width: 768px) {
  .header {
    flex-direction: column;
    text-align: center;
    padding: 10px;
  }

  .header-left {
    flex-direction: column;
  }

  .nav-menu {
    flex-direction: column;
    gap: 10px;
  }

  .header-right {
    margin-top: 10px;
  }

  .search-container {
    width: 200px;
  }
}

.user-menu {
  display: flex;
  align-items: center;
  gap: 16px;
}

.notification-button {
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 20px;
  padding: 8px;
}

.notification-button:hover {
  color: #FF0558;
}

.profile-button {
  position: relative;
  cursor: pointer;
}

.profile-image {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #333;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  width: 240px;
  background-color: #1D1D1D;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  margin-top: 8px;
  z-index: 1000;
}

.dropdown-header {
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  gap: 12px;
}

.dropdown-header img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-name {
  color: #fff;
  font-size: 15px;
  font-weight: 500;
}

.user-email {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  margin-top: 2px;
}

.dropdown-content {
  padding: 8px;
}

.dropdown-content button {
  width: 100%;
  padding: 12px;
  text-align: left;
  background: none;
  border: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
}

.dropdown-content button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.logout-button {
  color: #FF0558 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,4DAA4D;EAC5D,WAAW;EACX,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,MAAM;AACN;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: black;\n  color: #888;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 1000;\n  height: 60px;\n}\n\n.header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50px;\n  right: 50px;\n  height: 1px;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\nbody, html {\n  background: #000 !important;\n}\n\nbody {\n  padding-top: 60px;\n}\n\na.custom-link {\n  display: inline-block;\n  padding: 10px 24px;\n  background: linear-gradient(90deg, #ff2e63 0%, #ff6f91 100%);\n  color: #fff;\n  border-radius: 8px;\n  font-weight: bold;\n  text-decoration: none;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.12);\n  transition: background 0.2s, transform 0.2s;\n}\n\na.custom-link:hover {\n  background: linear-gradient(90deg, #ff6f91 0%, #ff2e63 100%);\n  color: #fff;\n  transform: translateY(-2px) scale(1.04);\n  text-decoration: none;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  margin-left: 15px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 30px;\n  font-size: 24px;\n  font-weight: bold;\n  color: #ff2e63;\n  text-decoration: none;\n}\n\n.logo-image {\n  width: 130px;\n  height: auto;\n  object-fit: contain;\n  margin-left: 15px;\n}\n\n.nav-menu {\n  display: flex;\n  list-style: none;\n  gap: 35px;\n  margin: 0;\n  padding: 0;\n  height: 60px;\n  align-items: center;\n}\n\n.nav-menu li {\n  font-size: 16px;\n  cursor: pointer;\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.nav-menu li a {\n  text-decoration: none;\n  color: #888;\n  transition: all 0.3s;\n  padding: 21px 0;\n  position: relative;\n}\n\n.nav-menu li::after {\n  content: '';\n  position: absolute;\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: transparent;\n  transition: background-color 0.3s;\n}\n\n.nav-menu li:hover::after {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.nav-menu li.active::after {\n  background-color: white;\n}\n\n.nav-menu li.active a {\n  color: white;\n}\n\n.nav-menu li:hover a {\n  color: white;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  margin-right: 15px;\n  gap: 15px;\n}\n\n.auth-buttons {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.search-button,\n.notification-button {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.login-button,\n.signup-button {\n  background: none;\n  border: 1px solid white;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 5px;\n  text-decoration: none;\n  font-size: 14px;\n  transition: 0.3s;\n}\n\n.signup-button {\n  background-color: #ff2e63;\n  border: none;\n}\n\n.login-button:hover,\n.signup-button:hover {\n  opacity: 0.8;\n}\n\n/*검색 영역 스타일 */\n.search-container {\n  display: flex;\n  align-items: center;\n  background-color: #222;\n  border-radius: 20px;\n  padding: 5px 10px;\n  width: 280px;\n  position: relative;\n}\n\n.search-input {\n  border: none;\n  outline: none;\n  background: transparent;\n  color: white;\n  width: 100%;\n  padding: 5px;\n  font-size: 14px;\n  transition: opacity 0.4s ease;\n}\n\n.search-input.fade-out {\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n}\n\n.search-input.fade-in {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n}\n\n.search-icon {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  margin-left: 5px;\n  font-size: 18px;\n}\n\n.clear-btn {\n  background: none;\n  border: none;\n  color: gray;\n  cursor: pointer;\n  font-size: 14px;\n  position: absolute;\n  right: 10px;\n}\n\n.clear-btn:hover {\n  color: white;\n}\n\n.notification-icon {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n\n/*반응형*/\n@media screen and (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    text-align: center;\n    padding: 10px;\n  }\n\n  .header-left {\n    flex-direction: column;\n  }\n\n  .nav-menu {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .header-right {\n    margin-top: 10px;\n  }\n\n  .search-container {\n    width: 200px;\n  }\n}\n\n.user-menu {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.notification-button {\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  font-size: 20px;\n  padding: 8px;\n}\n\n.notification-button:hover {\n  color: #FF0558;\n}\n\n.profile-button {\n  position: relative;\n  cursor: pointer;\n}\n\n.profile-image {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: #333;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 240px;\n  background-color: #1D1D1D;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  margin-top: 8px;\n  z-index: 1000;\n}\n\n.dropdown-header {\n  padding: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dropdown-header img {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.user-name {\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.user-email {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 13px;\n  margin-top: 2px;\n}\n\n.dropdown-content {\n  padding: 8px;\n}\n\n.dropdown-content button {\n  width: 100%;\n  padding: 12px;\n  text-align: left;\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.dropdown-content button:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.logout-button {\n  color: #FF0558 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
